<style lang="scss" scoped="scoped">
// ::-webkit-scrollbar {
// 	width: 0 !important
// }
::-webkit-scrollbar {
  display: none;
}

.vue-grid-item {
  background: #202027;
  // overflow: auto;
  box-sizing: border-box;
  position: relative;
}

.vue-grid-item.vue-grid-placeholder {
  background: #419fff !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: #419fff;
}

.bg {
  background: rgb(18, 18, 18);
}

// .vue-grid-layout::-webkit-scrollbar {
// 	width: 0 !important
// }

.module-grid {
  background: #202027;
}
</style>
<style lang="scss">
.el-popper {
  margin-right: 10px;
}

.monitorWorshop .el-input__inner {
  color: #419fff;
  border: none;
  background-color: transparent;
  text-align: right;
  width: 260px;
}

.monitorWorshop .el-cascader .el-input .el-icon-arrow-down {
  color: #419fff;
}

.monitorWorshop .el-input__inner::-webkit-input-placeholder {
  color: #419fff;
}
</style>
<template>
  <div style="display: inline;">
    <!--    :style="{ background: monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#121212' : '#000355' }"-->
    <div class="bg" style="position: absolute;height: 100%;width: 100%;box-sizing: border-box;background: #121212">
      <div ref="header" style="padding: 0px 34px  0px  34px;">
        <div class="module-grid" style="border-radius: 2px;width: 100%;height: 66px;padding:0px 20px;display: flex;justify-content: space-between;align-items: center;background: #1D1D24">
          <div style="width: 340px;cursor: pointer;">
            <img @click="utils.event_hub.$emit('TOGGLE_TABBAR', !store.state.is_monitor_full)" style="width: 176px;height: 38px;" :src="require('@@/assets/img/web/workshop/logo.png')" />
          </div>
          <div style="font-weight: 700;font-size: 30px;color: white;">
            {{ $t('weierzhusushengchanzhunbeikanban') }}
            <!--            {{-->
            <!--              store.state.customer.shortName-->
            <!--            }}-{{ $t("shebeimojuweixiu") }}-->
          </div>
          <div class="monitorWorshop" style="width: 340px;display: flex;flex-direction: column;justify-content: center;align-items: flex-end;">
            <p style="font-size: 14px;color:white;">{{ store.state.currentTime }}</p>
            <div style="display: flex;align-items: center;">
              <yi_data_select :type="'organization'" :ids.sync="orgId"></yi_data_select>
              <!--              <el-link @click="showBoardEdit()" style="color:#419FFF ;margin-left: 8px;font-size: 12px;" :style="{ color: monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#419FFF' : '#ECF5FF' }" icon="yicon yicon-pencil">-->
              <!--                {{ $t("bianjikanban") }}-->
              <!--              </el-link>-->
            </div>
          </div>
        </div>
      </div>
      <div style="padding: 0px 14px 34px  14px;">
        <grid-layout v-if="gridContainerHeight != 0" :layout.sync="layout" :col-num="24" :maxRows="24" :row-height="gridRowHeihgt" :is-draggable="false" :is-resizable="false" :is-mirrored="false" :vertical-compact="true" :margin="[20, 20]" :use-css-transforms="true" :style="{ height: gridContainerHeight + 'px' }" style="overflow: auto;">
          <grid-item v-for="item in layout" :x="item.x" :y="item.y" :w="item.w" :h="item.h" :i="item.i" :key="item.i">
            <component :ref="'grid_' + item.i" v-bind:is="item.i" :orgId="orgId" :backupMoldList="backupMoldList" :transferMoldList="transferMoldList" :adjustMachineList="adjustMachineList"></component>
          </grid-item>
        </grid-layout>
      </div>
    </div>

    <el-dialog :show-close="true" :title="$t('kanbanshezhi')" :visible.sync="isShowBoardEdit" :close-on-click-modal="false" width="874px" append-to-body>
      <setting ref="setting"></setting>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowBoardEdit = false">{{ $t("quxiao") }}</el-button>
        <el-button size="mini" @click="
          $refs.setting.save();
        isShowBoardEdit = false;
        " type="primary">
          {{ $t("baocun") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import VueGridLayout from "vue-grid-layout";
// import setting from "@@/pages/web/monitor/machine_model/setting";
import backup_mold from "@@/pages/web/customize/weier/monitor/production_preparation/backup_mold";
import transfer_mold from "@@/pages/web/customize/weier/monitor/production_preparation/transfer_mold";
import adjust_machine from "@@/pages/web/customize/weier/monitor/production_preparation/adjust_machine";

export default {
  name: "web_customize_weier_monitor_production_preparation_index",
  components: {
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    backup_mold: backup_mold,
    transfer_mold: transfer_mold,
    adjust_machine: adjust_machine,
    // setting: setting,
  },

  data() {
    return {
      orgId: null,
      isShowBoardEdit: false,
      gridContainerHeight: 0,
      gridRowHeihgt: 0,
      layout: [{
        "x": 0,
        "y": 0,
        "w": 24,
        "h": 8,
        "i": "backup_mold"
      },

      {
        "x": 0,
        "y": 0,
        "w": 24,
        "h": 8,
        "i": "transfer_mold"
      },
      {
        "x": 0,
        "y": 0,
        "w": 24,
        "h": 8,
        "i": "adjust_machine"
      },
      ],
      backupMoldList: [],
      transferMoldList: [],
      adjustMachineList: [],
    };
  },
  watch: {
    "orgId"(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      //保存
      localStorage.setItem("MONITOR_PRODUCT_PREPARATION_WR_" + this.store.state.customer.code, newValue)
      this.listData();
    },
  },
  created() {
    this.orgId = (localStorage.getItem("MONITOR_PRODUCT_PREPARATION_WR_" + this.store.state.customer.code) != null && !isNaN(parseInt(localStorage.getItem("MONITOR_PRODUCT_PREPARATION_WR_" + this.store.state.customer.code)))) ? parseInt(localStorage.getItem("MONITOR_PRODUCT_PREPARATION_WR_" + this.store.state.customer.code)) : this.store.state.organizations[0].id
    // this.setLayout();
    this.utils.event_hub.$emit("TOGGLE_TABBAR", true);
    this.timer = setInterval(() => {
      this.listData();
    }, 60000);
    this.listData();
  },
  activated() {
    this.resize();
  },
  mounted() {
    this.resize();
    this.utils.event_hub.$on("SetMachineModelLayout", () => {
      // this.setLayout();
    });
    this.utils.event_hub.$on("RESIZE", () => {
      this.resize();
    });
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.utils.event_hub.$off("SetMachineModelLayout");
  },
  methods: {
    async listData() {
      let response = await this.http.get('/custom/weier/notice/board/production/readiness', {
        params: {
          orgId: this.orgId,
        }
      });
      this.backupMoldList = response.data[0];//备模
      this.transferMoldList = response.data[1];//转模
      this.adjustMachineList = response.data[2];//调机
    },
    // setLayout() {
    //   this.monitorSetting = JSON.parse(localStorage.getItem("MONITOR_SETTING"));
    //   if (this.monitorSetting == null) {
    //     this.monitorSetting = {};
    //   }
    //   if (this.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == null) {
    //     this.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE = "black";
    //   }
    //   if (this.monitorSetting.MACHINE_MODEL_TEMPLATE == null) {
    //     this.monitorSetting.MACHINE_MODEL_TEMPLATE = "moren";
    //   }
    // },
    showBoardEdit() {
      this.isShowBoardEdit = true;
      this.$nextTick(() => {
        console.log(this.$refs.setting);
        this.$refs.setting.resetData();
      });
    },
    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (!this.$refs.header) {
          ``
          return;
        }
        this.gridContainerHeight = this.store.state.router_view_height - this.$refs.header.offsetHeight - 34;
        this.gridRowHeihgt = (this.gridContainerHeight - 480) / 24;
      }, 500);
    },
  },
};
</script>
